import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ErrorResponse } from '../../../Interface/ErrorResponse';
import { INITIAL_TABLE_STATE, State } from '../../../Interface/Hook/Interest/BridgingLoan/State';
import { InterestTableDTO } from '../../../Interface/Hook/Interest/InterestTableDTO';

import { tokenExpired } from '../../../Store/Auth/action';
import { getAll, getFiltered } from '../../../Service/Interest/BridgingLoanService';
import reduceBridgingLoanTableData from '../../../Reducer/ReduceBridgingLoanTableData';
import useGetLabels from '../UseGetLabels';
import { filterFinishedLoading, filterSubmitted } from '../../../Store/Filter/action';
import useFilterIsActual from '../UseFilterIsActual';
import { BRIDGING_LOANS } from '../../../Constants/Interest/Filter';

const useGetBridgingLoans = (labels: string[]): InterestTableDTO => {
    const dispatch = useDispatch();
    const isFilterActual = useFilterIsActual(BRIDGING_LOANS);

    const [{ error, data, headers, loading }, setState] = useState<State>(INITIAL_TABLE_STATE);
    const { allLabels } = useGetLabels(true);

    const handleReject = (errorResult: ErrorResponse): void => {
        errorResult.code === 403
            ? dispatch(tokenExpired())
            : setState({ error: true, data, headers, loading: false });
    };

    const fetchData = useCallback(() => {
        if (labels.length === 0) {
            getAll().then(
                result => {
                    setState({ error: false, loading: false, ...reduceBridgingLoanTableData(result, allLabels, true) });
                    dispatch(filterFinishedLoading());
                },
                handleReject
            );
            return;
        }

        if (!isFilterActual) {
            dispatch(filterSubmitted());
        }

        getFiltered(labels).then(
            result => {
                setState({ error: false, loading: false, ...reduceBridgingLoanTableData(result, allLabels, false) });
                dispatch(filterFinishedLoading());
            },
            handleReject
        );
    }, [dispatch, data, headers, labels]);

    useEffect(() => fetchData(), [labels]);

    return { data, error, headers, loading };
};

export default useGetBridgingLoans;
